import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAdobeInDesign12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconAdobeInDesign12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 2h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5zm2.378 1.1v4.9h.924V3.6zm2.333 4.795q.363.203.777.203.476 0 .72-.161.253-.16.372-.357h.126v.42h.868V3.6h-.882v1.827h-.126a.9.9 0 0 0-.203-.238 1 1 0 0 0-.35-.182 1.5 1.5 0 0 0-.525-.077q-.42 0-.777.21a1.5 1.5 0 0 0-.574.602q-.217.399-.217.966v.112q0 .567.217.966t.574.609m1.722-.826a.95.95 0 0 1-.68.259.95.95 0 0 1-.678-.259q-.273-.266-.273-.77v-.07q0-.504.273-.763a.93.93 0 0 1 .679-.266.92.92 0 0 1 .679.266q.273.26.273.763v.07q0 .504-.273.77"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAdobeInDesign12);
